/* diagnostic.js — Orak Diagnostic & Cartographie */

/* Reveal animations */
var rvObs = new IntersectionObserver(function(es) {
  es.forEach(function(e) {
    if (e.isIntersecting) { e.target.classList.add('on'); rvObs.unobserve(e.target); }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
document.querySelectorAll('.rv').forEach(function(el) { rvObs.observe(el); });

/* Accordion steps */
function toggleStepV(header) {
  var step = header.closest('.step-v');
  var isOpen = step.classList.contains('open');
  document.querySelectorAll('.step-v').forEach(function(s) { s.classList.remove('open'); });
  if (!isOpen) step.classList.add('open');
}

/* Scroll top */
var upBtn = document.getElementById('up');
if (upBtn) {
  window.addEventListener('scroll', function() {
    upBtn.classList.toggle('on', window.scrollY > 400);
  }, { passive: true });
  upBtn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

/* Smooth scroll anchors */
document.querySelectorAll('a[href^="#"]').forEach(function(a) {
  a.addEventListener('click', function(e) {
    var t = document.querySelector(a.getAttribute('href'));
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
  });
});

/* Formulaire → webhook Make.com (routage Pipedrive via 'follow-up'). */
var diagForm = document.getElementById('diagnostic-form');
if (diagForm) {
  diagForm.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn = diagForm.querySelector('button[type=submit]');
    var orig = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Envoi… <i class="ti ti-loader-2"></i>';
    var data = {};
    new FormData(diagForm).forEach(function(v, k) { data[k] = v; });
    var url = window.ORAK_MAKE_WEBHOOK;
    var done = function() {
      diagForm.style.display = 'none';
      var ok = document.getElementById('diagnostic-success');
      if (ok) { ok.style.display = 'block'; ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    };
    var fail = function() {
      var body = Object.keys(data).map(function(k) { return k + ': ' + data[k]; }).join('\r\n');
      window.location.href = 'mailto:contact@orak.fr?subject=' + encodeURIComponent('[Orak Diagnostic] Nouvelle demande') + '&body=' + encodeURIComponent(body);
      btn.disabled = false;
      btn.innerHTML = orig;
    };
    if (!url) { fail(); return; }
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
      .then(function(res) { if (!res.ok) throw new Error('bad-status'); done(); })
      .catch(fail);
  });
}
